import { createRouter, createWebHistory } from 'vue-router'
import { localGet } from '../utils/storage'
import { pageTitleMap } from '../config/constant'
import { isTimerLoginRedirect } from '../utils/timerLaunch'
import { installRouteLoadRecovery } from '../utils/routeLoadRecovery'

const router = createRouter({
    history: createWebHistory(), // hash模式：createWebHashHistory，history模式：createWebHistory
    routes: [
        {
            path: '/',
            name: 'login',
            component: () => import(/* webpackChunkName: "login" */ '../views/Login.vue')
        }
        ,{
            path: '/member',
            name: 'member',
            component: () => import(/* webpackChunkName: "member" */ '../views/Member.vue')
        }
        ,{
            path: '/week',
            name: 'week',
            component: () => import(/* webpackChunkName: "week" */ '../views/Week.vue')
        }
        ,{
            path: '/target',
            name: 'target',
            component: () => import(/* webpackChunkName: "target" */ '../views/Target.vue')
        }
        ,{
            path: '/task',
            name: 'task',
            component: () => import(/* webpackChunkName: "task" */ '../views/Task.vue')
        }
        ,{
            path: '/timer',
            name: 'timer',
            component: () => import(/* webpackChunkName: "timer" */ '../views/Timer.vue')
        }
        ,{
            path: '/statics',
            name: 'statics',
            component: () => import(/* webpackChunkName: "statics" */ '../views/Statics.vue')
        }
        ,{
            path: '/score',
            name: 'score',
            component: () => import(/* webpackChunkName: "score" */ '../views/Score.vue')
        }
    ]
})

/**/
router.beforeEach((to, from, next) => {
    let isAuth: boolean = !!localGet('x-token');
    // 如果不是 /login，判断是否有 token
    if (to.name !== 'login' && !isAuth) {
        // if(to.name){
        //     document.title = pageTitleMap[to.name.toString()]
        // }
        // 继续执行
        console.error("isAuth:"+isAuth)
        next({ name: 'login', ...(to.name === 'timer' ? { query: { redirect: 'timer' } } : {}) })

    } else if (to.name == 'login' && isAuth){
        next({name: isTimerLoginRedirect(to.query.redirect) ? 'timer' : 'task'})
    } else {
        // 跳至下个页面
        next()
    }

})

installRouteLoadRecovery(router)

export default router
